import { render } from "./follow.vue?vue&type=template&id=d3f698f2&scoped=true"
import script from "./follow.vue?vue&type=script&lang=js"
export * from "./follow.vue?vue&type=script&lang=js"

import "./follow.vue?vue&type=style&index=0&id=d3f698f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f698f2"]])

export default __exports__